/* eslint-disable eqeqeq */
import { Box, Typography } from "@mui/material";
import { formatNumber } from "../utils";
import { useTranslation } from "react-i18next";
import AppDialogHalfScreen from "./AppDialogHalfScreen";
import { useEffect, useState } from "react";
import FeeComponent from "../pages/withdraw/components/withdraw-options/crypto-payment-flow2/FeeComponent";
import { ArrowRight } from "@mui/icons-material";

export default function AppFeeComponent({ withdrawData }) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [feeStructure, setFeeStructure] = useState({});
    useEffect(() => {
        if (withdrawData && Object.keys(withdrawData).length) {
            setFeeStructure({
                totalFeeUsd: withdrawData?.feeCharged?.totalDeductedFee,
                fee: withdrawData.feeCharged?.processingFeeUsd || withdrawData.feeCharged?.localProcessingFeeFiat,
                feePercent: withdrawData.feeCharged?.processingFeePercent,
                swapFee: withdrawData?.feeCharged?.vendorSwapFee,
                localNetworkFee: withdrawData?.feeCharged?.localNetworkFee ||  withdrawData?.feeCharged?.networkFeeUsd,
                currency: withdrawData?.feeCharged?.baseCurrency
            });
        }
    }, [withdrawData]);
    return (
        <Box>
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                onClick={() => setShow(true)}
            >
                <Typography>{t('totalFees')}</Typography>
                <Box display={'flex'}  alignItems={'center'} sx={{ cursor: 'pointer' }}>
                    <Typography>
                        {formatNumber(withdrawData?.feeCharged?.totalDeductedFee)} {withdrawData?.currency}
                    </Typography>
                    <ArrowRight sx={{ color: "#F8F8F8" }} />
                </Box>

            </Box>
            <AppDialogHalfScreen setShow={setShow} show={show}>
                <FeeComponent feeStructure={feeStructure} setOpen={setShow} />
            </AppDialogHalfScreen>
        </Box>
    );
}
